import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/api/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function DriverList() {
  const [drivers, setDrivers] = useState([]);

  useEffect(() => {
    api.get('/drivers').then(({ data }) => {
      if (data.success) setDrivers(data.data || []);
    }).catch(() => toast.error('Erro ao carregar motoristas'));
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Motoristas</h1>
        <Link to="/drivers/new"><Button>+ Novo</Button></Link>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Listagem</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="divide-y">
            {drivers.length === 0 && <p className="text-muted-foreground py-4">Nenhum motorista encontrado.</p>}
            {drivers.map((d) => (
              <div key={d.id} className="py-3 flex items-center justify-between">
                <div>
                  <div className="font-medium">{d.first_name} {d.last_name}</div>
                  <div className="text-sm text-muted-foreground">{d.email_contact || d.phone}</div>
                </div>
                <Link to={`/drivers/edit/${d.id}`}><Button variant="ghost" size="sm">Editar</Button></Link>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
